import type { VehicleHistorySearch, VehicleSearchType } from '@services';
import { useStore } from '@stores';
import { message } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const isVin = (value: string): boolean => {
  const normalized = value.replace(/\s/g, '');
  return normalized.length === 17 && /^[A-Za-z0-9]+$/.test(normalized);
};

export const useVehicleHistorySearch = () => {
  const { serviceHistoryStore } = useStore();
  const navigate = useNavigate();
  const [term, setTerm] = useState('');

  useEffect(() => {
    serviceHistoryStore.getRecentSearches();
    serviceHistoryStore.getRecentlyAdded();
  }, [serviceHistoryStore]);

  const submit = useCallback(async () => {
    const trimmed = term.trim();
    if (trimmed.length < 2) {
      message.warning('Enter at least 2 characters');
      return;
    }
    const searchType: VehicleSearchType = isVin(trimmed) ? 'Vin' : 'Vrm';
    await serviceHistoryStore.logSearch({ searchTerm: trimmed, searchType });
    navigate(`/vehicle-histories/${encodeURIComponent(trimmed)}`);
  }, [term, serviceHistoryStore, navigate]);

  const applyRecent = useCallback(
    (entry: VehicleHistorySearch) => {
      navigate(`/vehicle-histories/${encodeURIComponent(entry.searchTerm)}`);
    },
    [navigate]
  );

  return {
    term,
    setTerm,
    submit,
    applyRecent,
  };
};
